import React from "react";
import {
  RiBehanceFill,
  RiFacebookBoxFill,
  RiInstagramFill,
  RiLinkedinBoxFill,
  RiMailFill,
  RiMap2Fill,
  RiSkypeFill,
  RiTelegramFill,
  RiTwitterFill,
  RiWhatsappFill,
  RiYoutubeFill,
  RiSnapchatFill,
  RiGlobeFill,
  RiWechatFill,
  RiLineFill,
} from "react-icons/ri";
import { FaTiktok } from "react-icons/fa";
import { COLORS } from "../../../config/theme";

const renderSocialIcon = (name, isBlack = false) => {
  const style = {
    backgroundColor: isBlack ? "black" : "white",
  };
  const { secondaryColor } = COLORS;
  switch (name) {
    case "facebook":
      return (
        <RiFacebookBoxFill
          className="icon-sizes"
          style={{ ...style, color: "#4267B2" }}
        />
      );
    case "instagram":
      return (
        <RiInstagramFill
          className="icon-sizes"
          style={{ ...style, color: "#E1306C" }}
        />
      );
    case "linkedin":
      return (
        <RiLinkedinBoxFill
          className="icon-sizes"
          style={{ ...style, color: "#0072b1" }}
        />
      );
    case "twitter":
      return (
        <RiTwitterFill
          className="icon-sizes"
          style={{ ...style, color: "#1DA1F2" }}
        />
      );
    case "skype":
      return (
        <RiSkypeFill
          className="icon-sizes"
          style={{ ...style, color: "#00aff0" }}
        />
      );
    case "behance":
      return (
        <RiBehanceFill
          className="icon-sizes"
          style={{ ...style, color: "#1769ff" }}
        />
      );
    case "youtube":
      return (
        <RiYoutubeFill
          className="icon-sizes"
          style={{ ...style, color: "#FF0000" }}
        />
      );
    case "maps":
      return (
        <RiMap2Fill
          className="icon-sizes"
          style={{ ...style, color: "#00ccd3" }}
        />
      );
    case "mail":
      return (
        <RiMailFill
          className="icon-sizes"
          style={{ ...style, color: "#2B9BCF" }}
        />
      );
    case "telegram":
      return (
        <RiTelegramFill
          className="icon-sizes"
          style={{ ...style, color: "#2AABEE" }}
        />
      );
    case "tiktok":
      return (
        <FaTiktok
          className="icon-sizes"
          style={{ ...style, color: isBlack ? "#ffffff" : "#000000" }}
        />
      );
    case "whatsapp":
      return (
        <RiWhatsappFill
          className="icon-sizes"
          style={{ ...style, color: "#25D366" }}
        />
      );
    case "snapchat":
      return (
        <RiSnapchatFill
          className="icon-sizes"
          style={{ ...style, color: "#ffd632" }}
        />
      );
    case "wechat":
      return (
        <RiWechatFill
          className="icon-sizes"
          style={{ ...style, color: "#7BB32E" }}
        />
      );
    case "line":
      return (
        <RiLineFill
          className="icon-sizes"
          style={{ ...style, color: "#06C755" }}
        />
      );
    default:
      return (
        <RiGlobeFill
          className="icon-sizes"
          style={{ ...style, color: secondaryColor }}
        />
      );
  }
};

export default renderSocialIcon;
